<template>
<!-- eslint-disable max-len -->
<div>
  <list-page
    name="User"
    use="_id"
    :display="display"
    page-prefix="/blade/users"
    :fetch="getUsers"
    :remove="deleteUser"
    :sort-options="sortOptions"
    :sort-functions="sortFunctions"
    :default-sort="defaultSort"
  ></list-page>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      sortByLastSignedIn: false,
      sortOptions: [
        'Last Active',
        'Last Signed In',
        'First Name',
        'Last Name',
        'Email Address',
        'Account Type',
        'Games List',
      ],
      sortFunctions: [
        this.lastActiveSort,
        this.signInSort,
        this.firstNameSort,
        this.lastNameSort,
        this.emailSort,
        this.roleSort,
        this.gameSort,
      ],
      defaultSort: 0,
    };
  },
  computed: {
    ...mapGetters([
      'classTypeName',
    ]),
  },
  mounted() {
    this.sortOptions.push(`${this.classTypeName} List`);
    this.sortFunctions.push(this.classSort);
  },
  methods: {
    ...mapActions([
      'getUsers',
      'deleteUser',
    ]),
    display({
      firstName,
      lastName,
      email,
      lastSignedIn,
      lastActive,
      fetchedGame,
      fetchedClass,
      roles,
    }) {
      const roleString = (roles == null || roles.length === 0) ? '' : ` (${roles[0]._id})`;
      const associationString =
        ((fetchedClass != null) ? ` (${fetchedClass})` :
          ((fetchedGame != null) ? ` (${fetchedGame})` : ''));
      // eslint-disable-next-line max-len
      return `${firstName} ${lastName} (${email})${roleString}${associationString}${(lastActive != null || lastSignedIn != null) ? ` (${(new Date(lastActive != null ? lastActive : lastSignedIn)).toLocaleString()})` : ''}`;
    },
    lastActiveSort(a, b) {
      const aTime = (a.lastActive != null) ? a.lastActive : a.lastSignedIn;
      const bTime = (b.lastActive != null) ? b.lastActive : b.lastSignedIn;
      if (aTime == null && bTime == null) return 0;
      if (aTime == null) return 1;
      if (bTime == null) return -1;
      return (aTime > bTime) ? -1 : ((aTime < bTime) ? 1 : 0);
    },
    signInSort(a, b) {
      if (a.lastSignedIn == null && b.lastSignedIn == null) return 0;
      if (a.lastSignedIn == null) return 1;
      if (b.lastSignedIn == null) return -1;
      return (a.lastSignedIn > b.lastSignedIn) ? -1 : ((a.lastSignedIn < b.lastSignedIn) ? 1 : 0);
    },
    gameSort(a, b) {
      const aAssignedGameName =
        (a.fetchedGame == null || a.fetchedClass != null)
          ? ''
          : a.fetchedGame.toLocaleLowerCase();
      const bAssignedGameName =
        (b.fetchedGame == null || b.fetchedClass != null)
          ? ''
          : b.fetchedGame.toLocaleLowerCase();
      if (aAssignedGameName === '' && bAssignedGameName !== '') return 1;
      if (aAssignedGameName !== '' && bAssignedGameName === '') return -1;
      return ((aAssignedGameName < bAssignedGameName)
        ? -1
        : ((aAssignedGameName > bAssignedGameName) ? 1 : 0));
    },
    classSort(a, b) {
      const aClassName =
        (a.fetchedClass == null)
          ? ''
          : a.fetchedClass.toLocaleLowerCase();
      const bClassName =
        (b.fetchedClass == null)
          ? ''
          : b.fetchedClass.toLocaleLowerCase();
      if (aClassName === '' && bClassName !== '') return 1;
      if (aClassName !== '' && bClassName === '') return -1;
      return ((aClassName < bClassName)
        ? -1
        : ((aClassName > bClassName) ? 1 : 0));
    },
    fieldSort(a, b, fieldName) {
      const aString = a[fieldName].toLocaleLowerCase();
      const bString = b[fieldName].toLocaleLowerCase();
      return ((aString < bString)
        ? -1
        : ((aString > bString) ? 1 : 0));
    },
    firstNameSort(a, b) {
      return this.fieldSort(a, b, 'firstName');
    },
    lastNameSort(a, b) {
      return this.fieldSort(a, b, 'lastName');
    },
    emailSort(a, b) {
      return this.fieldSort(a, b, 'email');
    },
    roleSort(a, b) {
      const aString = (a.roles == null || a.roles.length === 0) ? '' : a.roles[0]._id.toLocaleLowerCase();
      const bString = (b.roles == null || b.roles.length === 0) ? '' : b.roles[0]._id.toLocaleLowerCase();
      if (aString === '' && bString !== '') return 1;
      if (aString !== '' && bString === '') return -1;
      return ((aString < bString)
        ? -1
        : ((aString > bString) ? 1 : 0));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/UsersList.vue